import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppState } from 'src/store/appstate';
import { selectSubscribedChannels } from 'src/store/pubnub/pubnub-store.model';

@Component({
  selector: 'tcs-pubnub-subscribed-channels',
  templateUrl: './pubnub-subscribed-channels.component.html',
  styleUrls: ['./pubnub-subscribed-channels.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PubnubSubscribedChannelsComponent {
  public subscribedChannels$: Observable<string[]>;

  constructor(store: Store<AppState>) {
    this.subscribedChannels$ = store
      .select(selectSubscribedChannels())
      .pipe(map((c) => c.toArray()));
  }
}
